import type { LineManagerAssignment } from "../AssignLineManagerDeputy/AssignLineManagerDeputy.static"

export interface RemoveLineManagerAssignmentsProps {
  readonly assignments: readonly LineManagerAssignment[]
  readonly onRemove: (id: string) => void
}

export const localtext = {
  CurrentLineManager: "Current Line Manager",
  EmptyMessage: "No line manager deputy assignments have been submitted in this session. Use the Add Line Manager Deputy tab to create one.",
  EmptyTitle: "No active assignments",
  EndDate: "End Date",
  RemoveAction: "Remove early",
  RemoveDialogAction: "Remove early",
  RemoveDialogDescription: (currentLineManager: string, temporaryDeputy: string) => `Remove the assignment for ${currentLineManager} (deputy: ${temporaryDeputy})?`,
  RemoveDialogTicket: "Ticket URL",
  RemoveDialogTicketMismatch: "Enter the exact ticket URL used to create this assignment",
  RemoveDialogTitle: "Remove Assignment Early",
  RemoveDialogWarning: "This assignment has not yet reached its end date. Removing it will revoke the deputy's temporary access immediately.",
  RemoveDialogWarningTitle: "Early removal",
  SearchEmptyMessage: "Try a different line manager or deputy search term.",
  SearchEmptyTitle: "No matching assignments",
  SearchLabel: "Search",
  SearchPlaceholder: "Filter by line manager or deputy...",
  StartingDate: "Starting Date",
  Submitted: "Submitted",
  TemporaryDeputy: "Temporary Deputy",
  Ticket: "Ticket",
  TicketRequired: "This field is required",
} as const
